import { gql } from '@apollo/client';

export const GET_LEDGER_ACCOUNTS = gql`
  query getLedgerAccounts($clientId: ID!) {
    ledgerAccounts(clientId: $clientId) {
      id
      active
      role
      name
    }
  }
`;
